// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + (chunkId === 3674 ? "vendor_styles" : chunkId) + ".css";
};